import { PayloadAction } from '@reduxjs/toolkit';

import { SavedState, UndoRedoState } from 'editor/src/store/editorModules/undoRedo/types';

/** Rewrites the history, e.g. to take a cancelled edit out of the steps saved after it. */
const replaceStatesReducer = (
  state: UndoRedoState,
  action: PayloadAction<{ previous: SavedState[]; next: SavedState[] }>,
) => {
  state.previous = action.payload.previous;
  state.next = action.payload.next;
};

export default replaceStatesReducer;
